import { memo as Memo, useState } from 'react';

//* Components
import Container from 'components/common/Container';
import Collection from './Collection';

//* Styles
import CollectionsStyle from './style';

const Collections = Memo(({ collections }) => {
	//! States
	const [activeId, setActiveId] = useState();

	return (
		<CollectionsStyle>
			<Container className={`global-wrapper`}>
				{collections.map((collection, key) =>
					collection.products.length ? (
						<Collection
							key={key}
							{...collection}
							isOpened={activeId === collection.id}
							onCollapseClick={() => setActiveId(activeId === collection.id ? null : collection.id)}
						/>
					) : null
				)}
			</Container>
		</CollectionsStyle>
	);
});

export default Collections;
